import React from "react";

export default function FormattedDate(props){
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let day = days[props.time.getDay()];
    let dayNumber = props.time.getUTCDate();
    let hours = props.time.getHours();
    let minutes = props.time.getMinutes();
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let month = months[props.time.getMonth()];

    return(
        <p>{day}, {dayNumber} {month}, {hours}:{minutes}hs</p>    
        )

}